import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild, SimpleChanges } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentosService } from 'src/app/pages/services/documentos.service';
//import { SolicitudesDocumentosService } from 'src/app/pages/services/solicitudes/solicitudesdocumentos.service';
import { VacacionesService } from 'src/app/pages/services/vacaciones/vacaciones.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { environment } from 'src/environments/environment';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';

@Component({
  selector: 'app-listar-vacaciones',
  templateUrl: './listar-vacaciones.component.html',
  styleUrls: ['./listar-vacaciones.component.css']
})
export class ListarVacacionesComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';

  @Input() idTrabajador: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;   // variable para asignar paginator a matdatatable
  @ViewChild(MatSort) sort!: MatSort;
  dataSource = new MatTableDataSource();
  info_documento: any;

  loading: boolean = false;
  loadingData: boolean = false;


  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  constructor(
    private vacacionesApi: VacacionesService,
    private modalService: NgbModal,
    private alert: AlertHelper,
    private documentoService: DocumentosService,
    //private solicitudDocumentoService: SolicitudesDocumentosService,
  ) { }

  displayedColumns = [
    'folio',
    'Inicio',
    'Termino',
    'Habiles',
    'Inhabiles',
    'Pendiente',
    'Periodo',
    'Acciones'
  ];
  vacaciones: any;
  id: any;

  async ngOnInit() {
    await this.TraerVacaciones();
  }
  TraerVacaciones() {
    this.vacacionesApi.traerPorIdTrabajador(this.idTrabajador).subscribe(
      (res) => {
        this.loadingData = true;
        this.dataSource = new MatTableDataSource(res.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        //console.table(this.liquidaciones);
        this.loadingData = false;

      }
    );
  }
  open(content: any, vacacion: any) {
    this.modalService.open(content, { size: 'lg' });
    this.id = vacacion;
  }


  Descargar(id: any) {
    //console.log("Buscando archivo "+ id);
    webPreferences: {
      webSecurity: false
    }
    this.vacacionesApi.TraerArchivo(id).subscribe(
      (res) => {
        //console.log(res.data);
        this.info_documento = res.data[0];
        window.open(`${environment.API}/vacaciones/` + this.info_documento.ruta);
      }

    );
  }

  Borrar(id: number, estado: boolean) {
    if (!confirm('¿Seguro que desea eliminar la vacación?')) return;
    if (estado) {
      this.documentoService.eliminarDocumento(id, 'VACACION').subscribe((res: RequestResponse) => {
        this.vacacionesApi.eliminarContrato(id).subscribe((res: RequestResponse) => {
          this.alert.success_small('Se elimino la vacación');
          this.TraerVacaciones();
        }, (error) => {
          this.alert.error_small('Hubo un error al eliminar la vacación.');
          console.error(error);
        });
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el documento.');
        console.error(error);
      });
    } else {
      this.vacacionesApi.eliminarContrato(id).subscribe((res: RequestResponse) => {
        this.alert.success_small('Se elimino la vacación');
        this.TraerVacaciones();
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar la vacación.');
        console.error(error);
      });
    }
  }
  async eliminarRegistroVacacion(vacacion: any) {
    const res = await this.vacacionesApi.eliminarVacacionAsync(vacacion.id);
    if (res.success) {
      this.alert.success_small('Vacación eliminada.');
      await this.TraerVacaciones();
    } else {
      this.alert.error_small(res.msg);
    }

  }
  async eliminarVacacionDocumento(vacacion: any) {
    const res = await this.documentoService.eliminarDocumentoAsync(vacacion.id, 'VACACION');
    if (res.success) {
      this.alert.success_small('Se creo la solicitud para eliminar la vacacion.');
      await this.TraerVacaciones();
    } else {
      this.alert.error_small(res.msg);
    }
  }
}